
let initialized = false;

const initTooltips = () => {
    if (initialized) {
        return;
    }

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))

    if (tooltipTriggerList.length === 0) {
        return;
    }

    initialized = true;

    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });
}
// Initialize tooltips
window.addEventListener('DOMContentLoaded', initTooltips);
document.addEventListener('turbo:load', initTooltips);
